import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimTextField } from '../fields';
import { StateSelect } from '../StateSelect';

export const Box33_BillingProvider: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">33. BILLING PROVIDER INFO & PH #</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Controller
          name="billingProvider.name"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField field={field} fieldState={fieldState} size="small" placeholder="Provider Name" fullWidth />
          )}
        />
        <Controller
          name="billingProvider.address"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField field={field} fieldState={fieldState} size="small" placeholder="Address Line 1" fullWidth />
          )}
        />
        <Controller
          name="billingProvider.address2"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Address Line 2 (Optional)"
              fullWidth
            />
          )}
        />
        <Box sx={{ display: "flex", gap: 1 }}>
          <Controller
            name="billingProvider.city"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="City"
                fullWidth
                sx={{ flex: 1 }}
              />
            )}
          />
          <Controller
            name="billingProvider.state"
            control={control}
            render={({ field, fieldState }) => (
              <StateSelect {...field} size="small" placeholder="State" error={!!fieldState.error} helperText={fieldState.error?.message} />
            )}
          />
          <Controller
            name="billingProvider.zip"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="ZIP"
                sx={{
                  width: '100px',
                  minWidth: '100px',
                  maxWidth: '100px',
                  flex: '0 0 100px',
                }}
              />
            )}
          />
        </Box>
        <Controller
          name="billingProvider.phone"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField field={field} fieldState={fieldState} size="small" placeholder="Phone" fullWidth />
          )}
        />
        <Box sx={{ display: "flex", gap: 1 }}>
          <Controller
            name="billingProvider.npi"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="a. NPI"
                sx={formStyles.monospaceField}
              />
            )}
          />
          <Controller
            name="billingProvider.otherId"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                placeholder="b. Other ID"
                sx={formStyles.monospaceField}
              />
            )}
          />
        </Box>
      </Box>
    </>
  );
};